import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, center = false }) => (
  <FadeUp
    className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}
    y={20}
  >
    <span className="chapter-line" />
    <span
      data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`}
      className="text-xs font-semibold uppercase tracking-[0.35em] text-gold"
    >
      {num} — {label}
    </span>
    {center && <span className="chapter-line" />}
  </FadeUp>
);

export { EASE };
